import * as React from "react";
import { getSpecTitle } from "src/business/specification";
import { ZSecSpecRow } from "src/business/specification/ZSecSpecRow";

type DeletedSpec = ZSecSpecRow;

interface DeletedSpecsWarningProps {
  deletedSpec: DeletedSpec;
}

/**
 * Компонент предупреждения об удалении атрибутов и значений из спецификаций
 */
export const DeletedSpecsWarning: React.FC<DeletedSpecsWarningProps> = ({
  deletedSpec,
}) => {
  const formatCatalogs = (spec: DeletedSpec): string => {
    if (!spec.catalogs?.length) {
      return "";
    }
    const catalogNames = spec.catalogs
      .map((catalog) => `"${catalog.name}"`)
      .join(", ");
    return `в ${catalogNames}`;
  };
  const displayName = getSpecTitle(deletedSpec);
  const catalogsInfo = formatCatalogs(deletedSpec);
  return (
    <div>
      При сохранении будут безвозвратно удалены все атрибуты и значения,
      добавленные из спецификации {displayName} {catalogsInfo}
    </div>
  );
};
